import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'SPORTSPLAYERS';
export const SPORTS_PLAYERS_ACTION = getLifecycle(REDUCER_NAME, 'SPORTS_PLAYERS_ACTION');
